var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      !_vm.showNotes
        ? _c("ModalFullScreen", {
            attrs: {
              size: "lg",
              title: _vm.modalTitle,
              withBgClickEvent: true,
            },
            on: { close: _vm.closeModal },
            scopedSlots: _vm._u(
              [
                {
                  key: "content",
                  fn: function () {
                    return [
                      _c(
                        "ModalContent",
                        {
                          staticClass:
                            "relative h-96 w-full rounded-lg shadow-md p-4 font-outfit",
                        },
                        [
                          _c(
                            "LoadingOverlay",
                            {
                              attrs: {
                                loading:
                                  _vm.$apollo.queries.trackedTimes.loading,
                                hasData:
                                  !!_vm.trackedTimes &&
                                  _vm.trackedTimes.length > 0,
                                marginTop: "mt-32",
                                customPlaceholderMessage: "No time tracked",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "w-full table-height relative" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "space-y-1 sticky z-10" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "headings overflow-hidden pl-4",
                                          attrs: { id: "select-all-checkbox" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "w-28 text-sm font-medium text-color pl-4",
                                            },
                                            [_vm._v("Status")]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "w-28 border-l-1 text-sm font-medium text-color pl-4",
                                            },
                                            [_vm._v("Hours")]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "w-28 border-l-1 text-sm font-medium text-color pl-4",
                                            },
                                            [_vm._v("Date")]
                                          ),
                                          _c("div", [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "mr-6 text-primary",
                                              },
                                              [
                                                _c(
                                                  "svg",
                                                  {
                                                    attrs: {
                                                      width: "4",
                                                      height: "18",
                                                      viewBox: "0 0 4 18",
                                                      fill: "none",
                                                      xmlns:
                                                        "http://www.w3.org/2000/svg",
                                                    },
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        d: "M2 17C2.55228 17 3 16.5523 3 16C3 15.4477 2.55228 15 2 15C1.44772 15 1 15.4477 1 16C1 16.5523 1.44772 17 2 17Z",
                                                        stroke: "#e8f2fd",
                                                        "stroke-width":
                                                          "1.73188",
                                                        "stroke-linecap":
                                                          "round",
                                                        "stroke-linejoin":
                                                          "round",
                                                      },
                                                    }),
                                                    _c("path", {
                                                      attrs: {
                                                        d: "M2 10C2.55228 10 3 9.55228 3 9C3 8.44772 2.55228 8 2 8C1.44772 8 1 8.44772 1 9C1 9.55228 1.44772 10 2 10Z",
                                                        stroke: "#e8f2fd",
                                                        "stroke-width":
                                                          "1.73188",
                                                        "stroke-linecap":
                                                          "round",
                                                        "stroke-linejoin":
                                                          "round",
                                                      },
                                                    }),
                                                    _c("path", {
                                                      attrs: {
                                                        d: "M2 3C2.55228 3 3 2.55228 3 2C3 1.44772 2.55228 1 2 1C1.44772 1 1 1.44772 1 2C1 2.55228 1.44772 3 2 3Z",
                                                        stroke: "#e8f2fd",
                                                        "stroke-width":
                                                          "1.73188",
                                                        "stroke-linecap":
                                                          "round",
                                                        "stroke-linejoin":
                                                          "round",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "h-52 overflow-y-scroll scrollbar tracked-times",
                                      attrs: { id: "tracked-times" },
                                    },
                                    _vm._l(_vm.trackedTimes, function (time) {
                                      return _c(
                                        "div",
                                        {
                                          staticClass:
                                            "w-full flex justify-between h-20 items-center hover:bg-gray-50 text-gray-500 border-b border-gray-300 pl-4",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "w-28 pl-4" },
                                            [
                                              time.status.toLowerCase() ===
                                              "approved"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex items-center justify-start",
                                                    },
                                                    [
                                                      time.status.toLowerCase() ===
                                                      "approved"
                                                        ? _c("Badge", {
                                                            staticClass:
                                                              "text-badge capitalize",
                                                            attrs: {
                                                              color:
                                                                _vm.BadgeColor
                                                                  .ACTIVE,
                                                              value: "Approved",
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              time.status.toLowerCase() ===
                                              "declined"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex items-center justify-start",
                                                    },
                                                    [
                                                      time.status.toLowerCase() ===
                                                      "declined"
                                                        ? _c("Badge", {
                                                            staticClass:
                                                              "capitalize",
                                                            attrs: {
                                                              color:
                                                                _vm.BadgeColor
                                                                  .WARNING,
                                                              value: "Declined",
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              time.status.toLowerCase() ===
                                                "pending" ||
                                              time.status.toLowerCase() ===
                                                "created"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex items-center justify-start",
                                                    },
                                                    [
                                                      time.status.toLowerCase() ===
                                                        "pending" ||
                                                      time.status.toLowerCase() ===
                                                        "created"
                                                        ? _c("Badge", {
                                                            staticClass:
                                                              "capitalize",
                                                            attrs: {
                                                              color:
                                                                _vm.BadgeColor
                                                                  .INFO,
                                                              value:
                                                                "Pending Approval",
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "w-28 text-sm font-normal text-color pl-8",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.convertSecondsToReadable(
                                                      time.time
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "w-28 text-sm font-normal text-color pl-8",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.convertDateString(
                                                      time.tracked_date
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "h-fit pr-4 text-sm font-normal text-color pl-8",
                                            },
                                            [
                                              _c("MoreActionsClick", {
                                                staticClass: "relative",
                                                attrs: {
                                                  TooltipBoxStyle:
                                                    "tooltipResources",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "action-buttons",
                                                      fn: function () {
                                                        return [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "flex flex-col bg-white",
                                                            },
                                                            [
                                                              _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "actionLink",
                                                                  on: {
                                                                    click: () =>
                                                                      _vm.toggleShowNotes(
                                                                        time
                                                                      ),
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " View resource notes "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3065031058
            ),
          })
        : _vm._e(),
      _vm.showNotes
        ? _c("ModalFullScreen", {
            attrs: { size: "md", title: "Resource Notes" },
            on: { close: () => _vm.toggleShowNotes(_vm.focusedOnTime) },
            scopedSlots: _vm._u(
              [
                {
                  key: "content",
                  fn: function () {
                    return [
                      _c("ModalContent", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "h-full w-full overflow-y-auto z-0 whitespace-pre-line",
                          },
                          [_vm._v(" " + _vm._s(_vm.focusedOnTime.notes) + " ")]
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1542110090
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }